import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";
import rtlPlugin from "stylis-plugin-rtl";
import AppRoutes from "./components/AppRoutes";
import DialogManager from "./components/DialogManager";
import { CreateThemeWithMode } from "./utils/ThemeCustomization";

// Create rtl cache
const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [rtlPlugin],
});

export default function App() {
    // Update the theme only if the mode changes
    const themeValue = React.useMemo(() => {
        return CreateThemeWithMode("light");
    }, []);

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={themeValue}>
                <CssBaseline />
                <DialogManager>
                    <AppRoutes />
                </DialogManager>
            </ThemeProvider>
        </CacheProvider>
    );
}
